// extracted by css-extract-rspack-plugin
export default {"CardBaseWithSash":"drag-overlay-card-module__CardBaseWithSash__QY3kO"};